import type { FaireProductEntity } from "../../entity_types/product";

export const p_fj6ffahhcp: FaireProductEntity = {
  token: "p_fj6ffahhcp",
  type: "product",
  name: "Solid Color Ribbed Breathable Socks DP25A449",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Dipped Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/0debde5899729baf0aac4be4cf0e04f90fbb3d1bf099fdc55141ff740d2a71ef.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/efa49c74c595265024e0ae39a6a1e39a8ee6beeac5c24c9488287b51f4a52683.jpeg",
    "https://cdn.faire.com/fastly/24b8378eedb3dfad8dd2196339d2c0503f61d411ce189060b2fa6ccc841ff8e6.jpeg",
    "https://cdn.faire.com/fastly/92134478f331fedc0c0cedb1af4c500c5f24e50d1ec343c3792d9972f973e363.jpeg",
    "https://cdn.faire.com/fastly/38b295058c0e05407d4a2e1c847a101bcaae4bfa30b077e0907e1f6f1fac4626.jpeg",
    "https://cdn.faire.com/fastly/e80a8b4666839c7940de4b62aa7850f05c09fe3bf9a48441742129e5a5943d20.jpeg",
    "https://cdn.faire.com/fastly/5f241fb08562eb71014f4d40e46548bcb82562c4a971d5ef5e80e8df158d90a3.jpeg",
    "https://cdn.faire.com/fastly/caa2fbe392361167febf26a02ab7bcb2f33d77803ebaa82c6b50b7d47a9ee101.jpeg",
    "https://cdn.faire.com/fastly/ceb718428ae7a12238540210ac5f1c0343eb8f39b29194d92e969349323938d4.jpeg",
    "https://cdn.faire.com/fastly/6cc7bda81da1a805fb51398e2b527b4c5281bd142ea31581fef58063bfc89913.jpeg",
    "https://cdn.faire.com/fastly/9d970c26e80929984ffbb89f5b3022073d02acccb7854aadcdb8a43c014c8bd3.jpeg",
    "https://cdn.faire.com/fastly/649bba7ec7d6f280d7c7c5bc0f428bc704be292fb5d5b8722f41a82ce18f3500.jpeg",
    "https://cdn.faire.com/fastly/b976910d1267bef9ed59632efdf1b2e1a04c249246f9eb4f734fe531a4f317a9.jpeg",
  ],
  priceDollars: 2.9,
  description:
    "𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Solid Color\n• Simple \n• Breathable \n• Ribbed\n• Wearable in All Seasons\n• Absorbent\n• Soft\n• Stretchy Material\n\n𝐖𝐞𝐢𝐠𝐡𝐭: 0.06kg\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥:\n• Polyeste and Cotton\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐞:\n• Package include a pair of socks\n\n𝐍𝐨𝐭𝐞:\n• Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n• Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 5.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:41.199Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
